/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `HIGHLY_RECOMMEND` - Highly Recommend
 * * `RECOMMEND_WITH_HESITATION` - Recommend with Hesitation
 * * `DO_NOT_RECOMMEND` - Do Not Recommend
 */
export enum RecommendationStatusEnum {
    HIGHLY_RECOMMEND = 'HIGHLY_RECOMMEND',
    RECOMMEND_WITH_HESITATION = 'RECOMMEND_WITH_HESITATION',
    DO_NOT_RECOMMEND = 'DO_NOT_RECOMMEND',
}
